export default "__VITE_ASSET__D_QG86zk__"